export const KYC_ROUTE_PATHS = {
  kyc: '/users/kyc',
};

export const KYC_API_PATHS = {
  identityValidationProcessed: '/v1/api/platform/kyc/identity-validation/processed/:userId',
  identityValidationManual: '/v1/api/platform/kyc/identity-validation/manual',
  kycProviders: '/v1/api/platform/kyc/providers/identity-validation',
  userKycProviders: '/v1/api/platform/kyc/users/:userId/providers',
  deleteUserProvider: '/v1/api/platform/kyc/providers/:userId',
  providersConfiguration: '/v1/api/platform/kyc/providers/configuration',
  deleteProviderConfiguration: '/v1/api/platform/kyc/providers/configuration/:providerConfigId',
  documentValidationConfig: '/v1/api/platform/kyc/document-validation-config',
  sofValidations: '/v1/api/platform/kyc/sof-validations',
  sofProviderConfig: '/v1/api/platform/kyc/sof-provider-cfg',
  sofProviders: '/v1/api/platform/kyc/sof-provider',
  sofStatus: '/v1/api/platform/kyc/sof-status',
  sofParamsById: '/v1/api/platform/kyc/sof-params/:providerId',
  sofParams: '/v1/api/platform/kyc/sof-params',
  sofParamsUpdate: '/v1/api/platform/kyc/sof-params-update/:fileId',
  documents: '/v1/api/platform/kyc/documents',
  pinRecoverCases: '/v1/api/platform/kyc/users/pin/recover/cases',
  pinRecoverApprove: '/v1/api/platform/kyc/users/pin/recover/approve',
  pinRecoverReject: '/v1/api/platform/kyc/users/pin/recover/reject',
  faceMatchProcessed: '/v1/api/platform/kyc/users/face-match/processed',
  userDocument: '/v1/api/platform/kyc/users/:userId/document',
  batchReprocess: '/v1/api/platform/kyc/reprocess/batch',
};
